export const OffersLabelsEnum = {
    offerBank: 'Oferty bankowe',
    offerNonbank: 'Oferty ratalne',
    offerPayday: 'Oferty krótkoterminowe',
    offerLead: 'Oferty w procesie leadowym',
    offerLeadBank: 'Oferty bankowe w procesie leadowym',
    offerLeadNonbank: 'Oferty pozabankowe w procesie leadowym',
    offerAff: 'Oferty naszych partnerów',
    other: 'Pozostałe'
};